
































































































































































































































































































































































































































































































































































































































































































































































































import MarketSelect from '@/components/MarketSelect.vue';
import MultiSelect from '@/components/MultiSelect.vue';
import ResultView from '@/components/ResultView.vue';
import {TableHeaders} from '@/interfaces/components-data';
import {GlobalSettingsData, SelectBox} from '@/interfaces/global-data';
import {
  FtpDownloadProgress,
  GetTaskInfo,
  ResultTableHeaders,
  TaskAndFile,
  TaskData,
  TaskInfoFilterType,
  TaskNoteDTO,
  TaskParams,
  TaskStatus,
  TaskType,
  taskTypesRequiresConfirmation,
  isTaskInBackgroundGeneratableTypesAndStatuses,
  generatableRTNReportTaskStatuses,
  isRTNDocumentGeneratableTypesAndStatuses,
} from '@/interfaces/server-data';
import {EventBus} from '@/mixins/event-bus';
import { localizeTaskType, localizeTaskStatus } from '@/utils/backendValueLocalizer';
import Http from '@/mixins/http';
import {HttpExecutor} from '@/mixins/HttpExecutor';
import moment from 'moment';
import {Component, Mixins} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
import DatePicker from "@/components/UI/DatePicker.vue";
import 'vue2-datepicker/index.css';
import LocalData from '../mixins/local-data';
import Toast from '../mixins/toast';
import TaskStatusMixin from '../mixins/task-status';
import Card from '@/components/UI/Card.vue';
import CalcQueue from '@/components/CalcQueue.vue';

@Component({
    components: {
        ResultView,
        MultiSelect,
        MarketSelect,
        vSelect,
        DatePicker,
        Card,
        CalcQueue,
    },
    filters: {
        formatDate: (v: any) => {
            if (v) {
                return moment(new Date(+v)).format('DD/MM/YYYY HH:mm:ss');
            }
        },
    },
    methods: {
        replaceTxtToNumber(value) {
            if (value == null) {
                return null
            } else {
                return value.replace(/[^\d]/g, '');
            }
        },
    },
})
export default class Reports extends Mixins(LocalData, Toast, Http, TaskStatusMixin) {
    defaultIntSelectBox: Array<SelectBox<number>> = [{value: -1, label: this.$t('regular.common.all') as string}];
    taskIdFilter: string | null = null;
    taskIdFilterEdit: string | null = null;
    taskNoteFilter: string | null = null;
    taskNoteFilterEdit: string | null = null;
    allReportsIds: number[] = [];
    isAllReportsSelected: boolean = false;
    isLoadingAllReportIds: boolean = false;
    selectedReportsArray: number[] = [];
    updatedDateRange: string[] = [];
    updatedDateRangeEdit: string[] = [];
    defaultFilterValue = {value: -1, label: this.$t('regular.common.all') as string};
    secondDefaultFilterValue = {value: -2, label: this.$t('regular.common.notSelected') as string};
    defaultMultipleValue = [this.defaultFilterValue, this.secondDefaultFilterValue];

    selectMarket: number = this.defaultFilterValue.value;
    selectMarketEdit: number = this.defaultFilterValue.value;
    items: Array<SelectBox<number>> = [];

    categoryOptions: Array<SelectBox<number>> = [];
    categoryOfProduct: number = this.defaultFilterValue.value;
    categoryOfProductEdit: number = this.defaultFilterValue.value;

    subCategoryOptions: Array<SelectBox<number>> = this.defaultMultipleValue;
    subCategoryOfProduct: number[] = [];
    subCategoryOfProductEdit: number[] = [];

    selectGroup: number = this.defaultFilterValue.value;
    selectGroupEdit: number = this.defaultFilterValue.value;
    groupOptions: Array<SelectBox<number>> = this.defaultMultipleValue;

    selectFormat: number = this.defaultFilterValue.value;
    selectFormatEdit: number = this.defaultFilterValue.value;
    formatOptions: Array<SelectBox<number>> = this.defaultMultipleValue;

    selectRegion: number[] = [];
    selectRegionEdit: number[] = [];
    regionOptions: Array<SelectBox<number>> = this.defaultMultipleValue;

    selectCluster: number = this.defaultFilterValue.value;
    selectClusterEdit: number = this.defaultFilterValue.value;
    clusterOptions: Array<SelectBox<number>> = this.defaultMultipleValue;

    selectReportType: TaskType | null = null;
    selectReportTypeEdit: TaskType | null = null;
    usersFioList: Array<SelectBox<string>> = [];
    selectUserFio: string = 'All';
    selectUserFioEdit: string = 'All';

    table: TaskData[] = [];
    refreshTableTimeoutId?: number;
    isTableLoading: boolean = false;

    reportList: Array<SelectBox<TaskType | null>> = [
        {value: null, label: this.$t('regular.common.all') as string},
        {value: TaskType.REGULAR, label: this.$t('regular.taskTypes.regular') as string},
        {value: TaskType.PACKAGE_REGULAR, label: this.$t('regular.taskTypes.package') as string},
        {value: TaskType.PACKAGE_GENERAL, label: this.$t('regular.taskTypes.packageGeneral') as string},
        {value: TaskType.PACKAGE_GENERAL_KVI_CARTS, label: this.$t('regular.taskTypes.packageByBasket') as string},
        {value: TaskType.PACKAGE_GENERAL_KVI_RECOMMENDS, label: this.$t('regular.taskTypes.packageKviSearch') as string},
        {value: TaskType.PACKAGE_SALES, label: this.$t('regular.taskTypes.packageSales') as string},
        {value: TaskType.PACKAGE_GENERAL_SALES, label: this.$t('regular.taskTypes.packageGeneralSales') as string},
        {value: TaskType.PACKAGE_PROMOTION, label: this.$t('regular.taskTypes.packagePromotion') as string},
        {value: TaskType.PACKAGE_GENERAL_PROMOTION, label: this.$t('regular.taskTypes.packageGeneralPromotion') as string},
        {value: TaskType.PACKAGE_SCHEDULE, label: this.$t('regular.taskTypes.scheduled') as string},
        {value: TaskType.BRUT_FORCE, label: this.$t('regular.statuses.paramSearch') as string},
        {value: TaskType.SEARCH_KVI, label: this.$t('regular.taskTypes.kviSearch') as string},
        {value: TaskType.PROMO, label: this.$t('regular.columns.promo') as string},
        {value: TaskType.PACKAGE_EVENTS, label: this.$t('regular.taskTypes.eventCalc') as string},
        {value: TaskType.PACKAGE_EVENTS_GENERAL, label: this.$t('regular.taskTypes.eventCalcGeneral') as string},
        {value: TaskType.PACKAGE_PROMO_GENERAL_RECOMMENDS, label: this.$t('regular.columns.promoRecommendations') as string},
        {value: TaskType.PACKAGE_SCENARIO, label: this.$t('regular.taskTypes.scenario') as string},
        {value: TaskType.PACKAGE_FIXED_PRICE, label: this.$t('regular.taskTypes.packageFixed') as string},
        {value: TaskType.PACKAGE_GENERAL_FIXED_PRICE, label: this.$t('regular.taskTypes.packageGeneralFixed') as string},
        {value: TaskType.REGULAR_PRICE_EXP, label: this.$t('regular.taskTypes.regularCe') as string},
        {value: TaskType.SCHEDULED_PRICE_EXP, label: this.$t('regular.taskTypes.scheduledCe') as string},
    ];

    selectStatus: TaskStatus | null = null;
    selectStatusEdit: TaskStatus | null = null;
    statusList: Array<SelectBox<TaskStatus | null>> = [
        {value: null, label: this.$t('regular.common.all') as string},
        {value: TaskStatus.ARITHMETICEXCEPTION, label: this.$t('regular.columns.arithmeticError') as string},
        {value: TaskStatus.INQUEUE, label: this.$t('regular.statuses.inQueue') as string},
        {value: TaskStatus.WRITETOFILE, label: this.$t('regular.statuses.writingToFile') as string},
        {value: TaskStatus.CALCULATING, label: this.$t('regular.statuses.calculating') as string},
        {value: TaskStatus.ONAPPROVAL, label: this.$t('regular.statuses.pendingApproval') as string},
        {value: TaskStatus.EMPTYDATA, label: this.$t('regular.statuses.noDataForSelection') as string},
        {value: TaskStatus.RESTARTERROR, label: this.$t('regular.statuses.stopped') as string},
        {value: TaskStatus.REJECTED, label: this.$t('regular.statuses.rejected') as string},
        {value: TaskStatus.PARTIALLY_REJECTED, label: this.$t('regular.statuses.partiallyRejected') as string},
        {value: TaskStatus.SENT_TO_FINAL_APPROVAL, label: this.$t('regular.statuses.sentToFinalApprover') as string},
        {value: TaskStatus.WRITETOFILECOMPLETE, label: this.$t('regular.statuses.reportWritten') as string},
        {value: TaskStatus.ERROREXPORT, label: this.$t('regular.statuses.fileWriteError') as string},
        {value: TaskStatus.ERROR, label: this.$t('regular.statuses.noData') as string},
        {value: TaskStatus.PROMONOTRECOMMENDED, label: this.$t('regular.columns.promoNotRecommended') as string},
        {value: TaskStatus.CALCULATING_COMPLETE, label: this.$t('regular.statuses.calcCompleted') as string},
        {value: TaskStatus.CANCELREPORT, label: this.$t('regular.statuses.calcCancelled') as string},
        {value: TaskStatus.EXECUTIONEXCEPTION, label: this.$t('regular.statuses.ctmGapSingularMatrix') as string},
        {value: TaskStatus.APPROVED, label: this.$t('regular.statuses.approved') as string},
        {value: TaskStatus.PARTIALLY_APPROVED, label: this.$t('regular.statuses.partiallyApproved') as string},
    ];

    tableFields: TableHeaders[] = [
        {key: 'selected', label: ''},
        {key: 'id', label: '№'},
        {key: 'message', label: this.$t('regular.columns.status') as string},
        {key: 'updated', label: this.$t('regular.columns.changeTime') as string},
        {key: 'userFio', label: this.$t('regular.columns.user') as string},
        {key: 'progress', label: this.$t('regular.columns.progress') as string},
        {key: 'tradingNetworks.tradingName', label: this.$t('regular.columns.company') as string},
        {key: 'type', label: this.$t('regular.columns.type') as string},
        {key: 'group', label: this.$t('regular.columns.group') as string},
        {key: 'category', label: this.$t('regular.columns.category') as string},
        {key: 'subcategories', label: this.$t('regular.columns.subcategories') as string},
        {key: 'format', label: this.$t('regular.columns.format') as string},
        {key: 'region', label: this.$t('regular.columns.region') as string},
        {key: 'cluster', label: this.$t('regular.columns.cluster') as string},
        {key: 'fileResult', label: this.$t('regular.columns.actions') as string},
        {key: 'ftpSendingStatus', label: ''},
        {key: 'taskNote', label: this.$t('regular.columns.notes') as string},
        {key: 'taskNoteSecond', label: ''},
    ];

    newTableFields: any[] = [
        {dataIndex: 'selected', scopedSlots: { customRender: 'selected', title: 'selectedTitle' }, fixed: 'left', width: 50},
        {dataIndex: 'fileResult', title: this.$t('regular.columns.actions') as string, scopedSlots: { customRender: 'fileResult' }, fixed: 'left', stickyColumn: true, ellipsis: true, width: 200},
        {dataIndex: 'taskNote', title: this.$t('regular.columns.notes') as string, scopedSlots: { customRender: 'taskNote', filterDropdown: 'taskNoteFilter', filterIcon: "taskNoteFilterIcon" }, ellipsis: true, width: 150},
        {dataIndex: 'id', title: '№', scopedSlots: { filterDropdown: 'idFilter', filterIcon: "idFilterIcon" }, width: 80},
        {dataIndex: 'message', title: this.$t('regular.columns.status') as string, scopedSlots: { filterDropdown: 'messageFilter', filterIcon: "messageFilterIcon", customRender: 'message' }, ellipsis: true, width: 150},
        {dataIndex: 'updated', title: this.$t('regular.columns.changeTime') as string, customRender: (value: number) => new Date(value).toLocaleString('fr-FR'), scopedSlots: { filterDropdown: 'updatedFilter', filterIcon: "updatedFilterIcon" }, ellipsis: true, width: 150},
        {dataIndex: 'userFio', title: this.$t('regular.columns.user') as string, scopedSlots: { filterDropdown: 'userFioFilter', filterIcon: "userFioFilterIcon" }, ellipsis: true, width: 100},
        {dataIndex: 'progress', title: this.$t('regular.columns.progress') as string, scopedSlots: { customRender: 'progress' }, ellipsis: true, width: 100},
        {dataIndex: 'tradingNetworks.tradingName', title: this.$t('regular.columns.company') as string, scopedSlots: { filterDropdown: 'tradingNameFilter', filterIcon: "tradingNameFilterIcon" }, ellipsis: true, width: 100},
        {dataIndex: 'type', title: this.$t('regular.columns.type') as string, scopedSlots: { customRender: 'type', filterDropdown: 'typeFilter', filterIcon: "typeFilterIcon" }, ellipsis: true, width: 150},
        {dataIndex: 'group', title: this.$t('regular.columns.group') as string, scopedSlots: { filterDropdown: 'groupFilter', filterIcon: "groupFilterIcon" }, ellipsis: true, width: 120},
        {dataIndex: 'category', title: this.$t('regular.columns.category') as string, scopedSlots: { filterDropdown: 'categoryFilter', filterIcon: "categoryFilterIcon" }, ellipsis: true, width: 120},
        {dataIndex: 'subcategories', title: this.$t('regular.columns.subcategories') as string, customRender: (value: string[]) => value.join(', '), scopedSlots: { filterDropdown: 'subcategoriesFilter', filterIcon: "subcategoriesFilterIcon" }, ellipsis: true, width: 120},
        {dataIndex: 'format', title: this.$t('regular.columns.format') as string, scopedSlots: { filterDropdown: 'formatFilter', filterIcon: "formatFilterIcon" }, ellipsis: true, width: 120},
        {dataIndex: 'region', title: this.$t('regular.columns.region') as string, scopedSlots: { filterDropdown: 'regionFilter', filterIcon: "regionFilterIcon" }, ellipsis: true, width: 120},
        {dataIndex: 'cluster', title: this.$t('regular.columns.cluster') as string, scopedSlots: { filterDropdown: 'clusterFilter', filterIcon: "clusterFilterIcon" }, ellipsis: true, width: 120},

        {dataIndex: 'ftpSendingStatus', title: '', scopedSlots: { customRender: 'ftpSendingStatus' }, width: 0},
    ];

    pagination: any = {
        pageSize: 20,
        current: 1
    };

    showSendToFTPSingleReportModal: boolean = false;
    taskToView: TaskAndFile | null = null;
    packageSubtask: TaskAndFile | null = null;
    perPage: number = 20;
    currentPage: number = 1;
    totalRows: number = 0;
    isActiveCalculatingReports: boolean = false;
    isExistsUnfinishedReports: boolean = false;
    showDeleteSingleReportModal: boolean = false;
    taskIdForDelete: number = -1;
    taskIdForSendToFTP: number = -1;
    timeout: number = 1000;
    lastRequestId: number = 0;
    currentMainTab: string = "list"
    buttonSectionLoaderMap: Map<number, boolean> = new Map<number, boolean>();
    globalSettings: GlobalSettingsData = this.getGlobalSettingsDefaultData();
    isDeletingSelectedReports: boolean = false;
    isDownloadingSelectedReports: boolean = false;

    getButtonSectionLoaderState(taskId: number): boolean {
      return this.buttonSectionLoaderMap.get(taskId) || false
    }

    setButtonSectionLoaderState(taskId: number, state: boolean) {
      this.buttonSectionLoaderMap.set(taskId, state);
    }

    private httpExecutor = new HttpExecutor();

    private canBeShowTypes = [TaskType.PACKAGE_REGULAR, TaskType.PACKAGE_SCHEDULE, TaskType.REGULAR, TaskType.PROMO, TaskType.PACKAGE_PROMO, TaskType.PACKAGE_GENERAL,
        TaskType.PACKAGE_GENERAL_PROMO, TaskType.PACKAGE_SCENARIO, TaskType.PACKAGE_GENERAL_SCENARIO, TaskType.PACKAGE_EVENTS, TaskType.PACKAGE_EVENTS_GENERAL, TaskType.PACKAGE_GENERAL_KVI_CARTS,
        TaskType.PACKAGE_FIXED_PRICE, TaskType.PACKAGE_GENERAL_FIXED_PRICE, TaskType.SALES, TaskType.PACKAGE_SALES, TaskType.PACKAGE_GENERAL_SALES, TaskType.PACKAGE_GENERAL_AGGREGATE_SALES,
        TaskType.PACKAGE_PROMOTION, TaskType.PACKAGE_GENERAL_PROMOTION, TaskType.REGULAR_PRICE_EXP, TaskType.SCHEDULED_PRICE_EXP];

    created() {
        if (this.$disallowedModules.indexOf('promo') !== -1) {
            const index = this.reportList.findIndex((item) => {
                return item.value === TaskType.PROMO;
            });
            if (index !== -1) {
                this.reportList.splice(index, 1);
            }
        }
    }

    mounted() {
        EventBus.$on('calc', this.onCalcEventReceived);
        this.loadMarkets();
        this.checkUnfinishedAndCancelReports();
        this.fetchGlobalSettingsData();
        EventBus.$on('ftpDownloadProgress', this.onFtpDownloadProgressReceived);
        // Вызов идет из ResultView.vue. Работает, не трогать :)
        EventBus.$on('packageSubTaskView', this.onPackageSubTaskViewEventReceived)
        if (this.$route.params.hasOwnProperty('id')) {
            this.viewReport(this.$route.params.id);
        }

        const pager = { ...this.pagination };
        pager.current = 1;
        this.pagination = pager;
        this.fetchList({
            currentPage: this.pagination.current,
            perPage: this.pagination.pageSize
        }, () => {});
    }

    onTableChange(pagination: any) {
        const pager = { ...this.pagination };
        pager.current = pagination.current;
        this.pagination = pager;
        this.fetchList({
            currentPage: pagination.current,
            perPage: pagination.pageSize,
        }, () => {});
    }

    onCalcEventReceived(data: TaskData) {
        this.updateTaskRowStatus(data);
    }

    onPackageSubTaskViewEventReceived(task: ResultTableHeaders) {
        this.selectPackageResult(task);
    }

    onFtpDownloadProgressReceived(ftpSendProgress: FtpDownloadProgress) {
        console.log("onFtpDownloadProgressReceived")
        this.updateSendToFtpProgress(ftpSendProgress);
    }

    beforeDestroy() {
        clearTimeout(this.refreshTableTimeoutId)
        EventBus.$off('calc', this.onCalcEventReceived);
        EventBus.$off('ftpDownloadProgress', this.onFtpDownloadProgressReceived);
        EventBus.$off('packageSubTaskView', this.onPackageSubTaskViewEventReceived)
    }

    updateSendToFtpProgress(ftpSendProgress: FtpDownloadProgress) {
        const index = this.table.findIndex((item) => {
            return item.id === ftpSendProgress.taskId;
        });
        if (index !== -1) {
            this.table[index].ftpSendingStatus = ftpSendProgress.ftpSendStatus;
        }
    }

    fetchGlobalSettingsData() {
      this.httpGetGlobalSettings()
          .then((r) => {
            this.globalSettings = r.data;
          })
          .catch((ex) => {
            this.showError(this.$t('regular.errors.loadGlobalSettingsFailed') as string)
          })
    }

    updateTaskRowStatus(data: TaskData) {
        const index = this.table.findIndex((item) => {
            return item.id === data.id;
        });
        if (index === -1) {
            this.table = [data, ...this.table];
            return;
        }
        this.table[index].message = data.message;
        this.table[index].updated = data.updated;
        this.table[index].fileResult = data.fileResult;
        this.table[index].progress = data.progress;
        this.table[index].status = data.status;
        this.checkUnfinishedAndCancelReports();
        // Костыль - обновляем страницу отчетов, т.к. Пакетный общий отчет создается с пустой группой, категорией и тд и только потом они подтягиваются в виде списка при загрузке страницы
        if (data.type === 'Пакетный общий' && data.status === 'WriteToFileComplete') {
            this.handleFilter();
        }
    }

    updateSelectMarket(market: number) {
        this.$log.debug('Calc updateSelectMarket', market);
        this.selectMarket = market;
        this.resetData(null);
        if (LocalData.zeroToNull(market) != null) {
          this.loadFilterOptions()
        }
    }

    onMainTabsClicked(key:string) {
        this.currentMainTab = key
        switch (key) {
            case "list":
                // @ts-ignore
                this.handleFilter()
                break;
            default:
                return
        }
    }

    showProgressBar(status: string, rtnReportGenerationStatus?: string): boolean {
        return (
            status === 'Calculating'
            || status === 'CalculatingComplete'
            || status === 'WriteToFile'
            || rtnReportGenerationStatus === 'WriteToFile'
        );
    }

    showCancelReportsButton(): boolean {
        return !this.isActiveCalculatingReports || this.selectedReportsArray.length === 0;
    }

    showRestartReportsButton(): boolean {
        return !this.isExistsUnfinishedReports || this.selectedReportsArray.length === 0;
    }

    showCompleteMessage(status: string, rtnReportGenerationStatus?: string): boolean {
        return status === 'WriteToFileComplete' && rtnReportGenerationStatus !== 'WriteToFile';
    }

    showDeleteTaskButton(status: string): boolean {
        return (status === TaskStatus.WRITETOFILECOMPLETE
                || status === TaskStatus.EMPTYDATA
                || status === TaskStatus.PROMONOTRECOMMENDED
                || status === TaskStatus.EXECUTIONEXCEPTION
                || status.includes('Error')
                || status.includes('Exception')
                || status === TaskStatus.INQUEUE
                || status === TaskStatus.CANCELREPORT
                || status === TaskStatus.REJECTED
                || status === TaskStatus.ONAPPROVAL
                || status === TaskStatus.APPROVED
                || status === TaskStatus.PARTIALLY_APPROVED
                || status === TaskStatus.PARTIALLY_REJECTED
                || status === TaskStatus.SENT_TO_FINAL_APPROVAL);
    }

    checkUnfinishedAndCancelReports() {
        this.httpCheckUnfinishedReports()
                .then((result) => {
                    this.isActiveCalculatingReports = result.data.length > 0;

                })
                .catch(() => {
                    this.showError(this.$t('regular.errors.unexpectedUnfinishedCalcError') as string);
                });

        this.httpCheckCancelReports()
                .then((result) => {
                    this.isExistsUnfinishedReports = result.data.length > 0;

                })
                .catch(() => {
                    this.showError(this.$t('regular.errors.unexpectedCancelledCalcError') as string);
                });
    }

    cancelAllCalculatingReports(reportsArray: number[]) {
        this.httpCancelTask(reportsArray)
                .then((result) => {
                    result.data.forEach((id) => {
                        this.showInfo(this.$t('regular.notifications.reportCancelled') as string + id);
                        this.checkUnfinishedAndCancelReports();
                        this.handleFilter();
                    });

                })
                .catch(() => {
                    this.showError(this.$t('regular.errors.cancelReportFailed') as string);
                });
    }

    restartAllCalculatingReports(reportsArray: number[]) {
        this.httpRestartTask(reportsArray)
                .then((result) => {
                    result.data.forEach((id) => {
                        this.showInfo(this.$t('regular.notifications.reportRestarted') as string + id);
                        this.checkUnfinishedAndCancelReports();
                        this.handleFilter();
                    });

                })
                .catch(() => {
                    this.showError(this.$t('regular.errors.restartReportFailed') as string);
                });
    }

    beforeDeleteFileDialog(taskId: number) {
        this.showDeleteSingleReportModal = true
        this.taskIdForDelete = taskId;
    }

    recalculateGeneralTask(generalTaskId: number) {
        this.httpRecalculateGeneralTask(generalTaskId)
                .then((result) => {
                    this.showInfo(this.$t('regular.notifications.reportRecalculating') as string + generalTaskId);
                    this.handleFilter();

                })
                .catch(() => {
                    this.showError(this.$t('regular.errors.unexpectedRecalcError') as string);
                });
    }

    beforeSendToFTPDialog(taskId: number) {
        this.showSendToFTPSingleReportModal = true
        this.taskIdForSendToFTP = taskId;
    }

    showDeleteFileDialog(taskId: number) {
        this.setButtonSectionLoaderState(taskId, true);
        this.deleteTask([taskId]).finally(() => {
            this.setButtonSectionLoaderState(taskId, false);
        });
    }

    showDeleteCheckedReports(taskIds: number[]) {
        this.isDeletingSelectedReports = true;
        this.deleteTask(taskIds).finally(() => {
            this.isDeletingSelectedReports = false;
        });
        this.selectedReportsArray = [];
    }

    inputTaskNote(taskNoteParam: string, taskId: number) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
            const taskParam: TaskNoteDTO = {
                taskNote: taskNoteParam,
            }
            this.httpCreateNote(taskId, taskParam);
        }, 500);
    }

    downloadFile(taskId: number, file: string) {
        this.setButtonSectionLoaderState(taskId, true);
        
        this.$http.get('/api/task/result', {
            method: 'GET',
            responseType: 'blob',
            params: {
                taskId
            },
        })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', file.endsWith('.xlsx') ? file : 'report.xlsx');
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((e) => {
                    this.showError(this.$t('regular.errors.downloadReportFailed') as string);
                })
                .finally(() => {
                    this.setButtonSectionLoaderState(taskId, false);
                });
    }

  downloadRTNReportFile(taskId: number, file: string) {
    this.$http.get('/api/task/result-for-rtn', {
      method: 'GET',
      responseType: 'blob',
      params: {
        taskId
      },
    })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', file.endsWith('.xlsx') ? file : 'report.xlsx');
          document.body.appendChild(link);
          link.click();
        })
        .catch((e) => {
          this.showError(this.$t('regular.errors.downloadReportFailed') as string);
        });
  }

    downloadFinalReportFile(taskId: number, file: string) {
      this.httpDownloadFinalReportFile(taskId, file)
    }

    generateReport(task: TaskData) {
      this.httpStartGeneratingReport(task.id)
          .then(() => {
            task.status = TaskStatus.WRITETOFILE
            this.refreshTable()
          })
          .catch((e) => {
            if (e.response) {
              if (e.response.status === 422) {
                this.showError(this.$t('regular.errors.reportRowLimitExceeded') as string);
              } else {
                this.showError(this.$t('regular.errors.reportGenerationError') as string)
              }
            }
          });
    }

    generateRTNReport(task: TaskData) {
      this.httpStartGeneratingRTNReport(task.id)
          .then(() => {
            task.rtnReportGenerationStatus = TaskStatus.WRITETOFILE
            this.refreshTable()
          })
          .catch((e) => {
            if (e.response) {
              if (e.response.status === 422) {
                this.showError(this.$t('regular.errors.reportRowLimitExceeded') as string);
              } else {
                this.showError(this.$t('regular.errors.reportGenerationError') as string)
              }
            }
          });
    }

    downloadFiles(taskIds: number[]) {
        if (taskIds.length === 0) {
            return;
        }
        
        this.isDownloadingSelectedReports = true;
        
        const downloadPromises = taskIds.map((id) => {
            const tableRow = this.table.find((item) => {
                return item.id === id
            });
            return this.$http.get('/api/task/result', {
                method: 'GET',
                responseType: 'blob',
                params: {
                    taskId: id,
                },
            })
                    .then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        // tslint:disable-next-line: no-non-null-assertion
                        link.setAttribute('download', tableRow!!.fileResult);
                        document.body.appendChild(link);
                        link.click();
                    })
                    .catch((e) => {
                        this.showError(this.$t('regular.errors.downloadReportFailed') as string);
                    });
        });
        
        Promise.all(downloadPromises).finally(() => {
            this.isDownloadingSelectedReports = false;
        });
    }

    deleteTask(taskIds: number[]) {
        return this.$http.post('/api/task/delete', taskIds)
                .then(() => {
                    taskIds.forEach((id) => {
                        const index = this.table.findIndex((item) => {
                            return item.id === id
                        });
                        if (index !== -1) {
                            this.table.splice(index, 1);
                        }
                    });
                    this.taskToView = null;
                    this.checkUnfinishedAndCancelReports();
                })
                .catch((err) => {
                    this.showError(this.$t('regular.errors.deleteReportFailed') as string);
                });
    }

    buildTaskListParams(ctx: { perPage: number; currentPage: number }): TaskParams {
        const params: TaskParams = {
            size: ctx.perPage,
            page: ctx.currentPage - 1,
        };

        params.taskIdFilter = this.taskIdFilter;
        params.taskNoteFilter = this.taskNoteFilter;

        const userFio = this.selectUserFio;
        if (userFio != null && userFio !== 'All') {
            params.userFio = userFio;
        }

        const status = this.selectStatus;
        if (status != null) {
            params.status = status;
        }

        const company = LocalData.zeroToNull(this.selectMarket);
        if (company != null) {
            params.tradingId = company;
        }

        const type = this.selectReportType;
        if (type != null) {
            params.type = type;
        }

        const group = LocalData.zeroToNull(this.selectGroup);
        if (group != null) {
            params.group = group;
        }

        const category = LocalData.zeroToNull(this.categoryOfProduct);
        if (category != null) {
            params.category = category;
        }

        const subCategory = LocalData.filterNumberArrays(this.subCategoryOfProduct, true);
        if (subCategory != null) {
            params.subcategories = subCategory.join(',');
        }

        const storeFormat = LocalData.zeroToNull(this.selectFormat);
        if (storeFormat != null) {
            params.storeFormat = storeFormat;
        }

        const region = LocalData.filterNumberArrays(this.selectRegion, true);
        if (region != null) {
            params.storeRegions = region.join(',');
        }

        const cluster = LocalData.zeroToNull(this.selectCluster);
        if (cluster != null) {
            params.storeCluster = cluster;
        }
        if (this.updatedDateRange.length > 0) {
            params.dateBefore = this.updatedDateRange[0];
            params.dateAfter = this.updatedDateRange[1];
        }

        return params;
    }

    fetchList(ctx: any, callback: (items: any[]) => void, isAutoRefresh: boolean = false) {
      const requestId = ++this.lastRequestId;

      if (!isAutoRefresh) {
            this.isTableLoading = true;
            clearTimeout(this.refreshTableTimeoutId);
        }

        const params = this.buildTaskListParams(ctx);
        this.httpGetTaskList(params)
                .then((response) => {
                    if (requestId !== this.lastRequestId) return;

                    const pagination = { ...this.pagination };
                    pagination.total = response.data.totalElements;
                    this.pagination = pagination;
                    this.table = response.data.content;

                    if (this.table.length === 0) {
                        this.showInfo(this.$t('regular.common.nothingFound') as string)
                    }
                    callback(response.data.content);
                    this.refreshTableTimeoutId = setTimeout(() => {this.fetchList(ctx, callback, true)}, 10000)
                })
                .catch((e) => {
                    this.showError(this.$t('regular.errors.loadReportListFailed') as string);
                    callback([]);
                })
                .finally(() => {
                    if (requestId === this.lastRequestId && !isAutoRefresh) {
                        this.isTableLoading = false;
                    }
                });

        if (this.usersFioList.length === 0) {
            this.httpGetUsersFio()
                    .then((response) => {
                        this.usersFioList = response.data.map((i) => {
                            return {value: i, label: i}
                        });
                        this.usersFioList.unshift({value: 'All', label: this.$t('regular.common.all') as string});
                    })
                    .catch((e) => {
                        this.showError(this.$t('regular.errors.loadUserListFailed') as string);
                    });
        }
    }

    selectOrClearAllReports(selected: boolean) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        if (!selected) {
          this.isAllReportsSelected = false;
          this.selectedReportsArray = [];
          this.isLoadingAllReportIds = false;
          return;
        }
        const ctx = {
          perPage: this.pagination.pageSize,
          currentPage: this.pagination.current,
        };
        const params = this.buildTaskListParams(ctx);
        this.isLoadingAllReportIds = true;
        this.httpGetAllReportsIds(params)
            .then((response) => {
              this.allReportsIds = response.data;
              this.isAllReportsSelected = true;
              this.selectedReportsArray = [...this.allReportsIds];
            })
            .catch(() => {
              this.isAllReportsSelected = false;
              this.showError(this.$t('regular.errors.loadReportNumbersFailed') as string);
            })
            .finally(() => {
              this.isLoadingAllReportIds = false;
            });
      }, 100);
    }

    isSelectedTaskId(taskId: number) {
        const index = this.selectedReportsArray.findIndex((id) => {
            return id === taskId
        });
        return index !== -1;
    }

    setSelectedTaskId(taskId: number, selected: boolean) {
        const index = this.selectedReportsArray.findIndex((id) => {
            return id === taskId
        });
        if (selected) {
            if (index === -1) {
                this.selectedReportsArray.push(taskId);
            }
        } else {
            if (index !== -1) {
                this.selectedReportsArray.splice(index, 1);
            }
        }
    }

    loadMarkets() {
        this.httpLoadTradingNetworks(true)
                .then((json) => {
                    this.items = json.data
                            .map((item) => {
                                return item;
                            })
                            .sort((a, b) => {
                                return a.id === b.id ? 0 : +(a.id > b.id) || -1;
                            })
                            .map((i) => {
                                return {value: i.id, label: i.tradingName};
                            });

                    this.items = [{
                        value: -1,
                        label: this.$t('regular.common.allTypo') as string,
                    }, ...this.items];
                })
                .catch((err) => {
                });
    }

    moveFiltersToTableFilters(taskId: number) {
        this.showAction(
                this.$t('regular.confirm.setDefaultCalcParams') as string,
                {
                    position: 'top-center',
                    type: 'info',
                    singleton: true,
                    duration: 10000,
                    icon: 'filter',
                    theme: 'bubble',
                    action: [{
                        text: this.$t('regular.common.yes') as string,
                        onClick: () => {
                            const taskIds: number[] = []
                            taskIds.push(taskId)
                            this.httpMoveTaskFilter(taskIds)
                                    .then(() => {
                                        this.showInfo(this.$t('regular.notifications.defaultParamsSet') as string);

                                    })
                                    .catch(() => {
                                        this.showError(this.$t('regular.errors.setFilterForReportFailed') as string + taskId);
                                    });
                        },
                    }],
                });
    }

    moveFiltersToTableFiltersForCheckedReports(taskIds: number[]) {
        this.showAction(
                this.$t('regular.confirm.setDefaultForSelectedCalcs') as string,
                {
                    position: 'top-center',
                    type: 'info',
                    singleton: true,
                    duration: 10000,
                    icon: 'filter',
                    theme: 'bubble',
                    action: [{
                        text: this.$t('regular.common.yes') as string,
                        onClick: () => {
                            this.httpMoveTaskFilter(taskIds)
                                    .then(() => {
                                        this.showInfo(this.$t('regular.notifications.defaultParamsSet') as string);

                                    })
                                    .catch(() => {
                                        this.showError(this.$t('regular.errors.setFiltersForReportsFailed') as string);
                                    });
                        },
                    }],
                });
    }

    sendFileToFtpServer(taskId: number) {
        this.setButtonSectionLoaderState(taskId, true)
        this.httpSendReportToFtpServer([taskId])
                .then((response) => {
                    this.fetchList({
                        currentPage: this.pagination.current,
                        perPage: this.pagination.pageSize,
                    }, () => {});
                    const message: string = this.$t('regular.notifications.reportSentForApproval') as string;
                    this.showInfo(message);
                })
                .catch((exception) => {
                    this.showError(this.$t('regular.errors.sendReportForApprovalFailed') as string + exception.response.data.message);
                })
            .finally(() => {
              this.setButtonSectionLoaderState(taskId, false)
            });
    }

    sendFileToFtpServerForCheckedReports(taskIds: number[]) {
        const filteredTable = this.table.filter((task) => {
            return taskIds.includes(task.id) && task.status !== TaskStatus.APPROVED && task.status !== TaskStatus.ONAPPROVAL
        });
        const filteredIds = filteredTable.map((task) => {
            return task.id
        });
        this.httpSendReportToFtpServer(filteredIds)
                .then((response) => {
                    const message: string = this.$t('regular.notifications.reportsSentForApproval') as string;
                    this.showInfo(message);
                })
                .catch((exception) => {
                    this.showError(this.$t('regular.errors.sendForApprovalError') as string + exception.response.data.message);
                });
    }

    canBeSendFileToFtpServerForCheckedReports(taskIds: number[]): boolean {
        const filteredTable = this.table.filter((task) => {
            return taskIds.includes(task.id)
                && task.status !== TaskStatus.APPROVED
                && task.status !== TaskStatus.ONAPPROVAL
                && task.status !== TaskStatus.SENT_TO_FINAL_APPROVAL
                // && task.revaluationStatus !== TaskStatus.ONAPPROVAL
                && !task.needRecalculatePackageTask
        });
        return filteredTable.length === 0
    }

    canBeSaveForCheckedReports(taskIds: number[]): boolean {
        const filteredTable = this.table.filter((task) => {
            return taskIds.includes(task.id) && !task.needRecalculatePackageTask
        });
        return filteredTable.length === 0
    }

    canBeMoveFiltersToTableFiltersForCheckedReports(taskIds: number[]): boolean {
        const filteredTable = this.table.filter((task) => {
            return taskIds.includes(task.id) && task.typeMachine !== TaskType.PACKAGE_PROMO_GENERAL_RECOMMENDS && task.typeMachine !== TaskType.SEARCH_KVI && task.typeMachine !== TaskType.PACKAGE_GENERAL
                    && task.typeMachine !== TaskType.PACKAGE_GENERAL_SCENARIO && task.typeMachine !== TaskType.PACKAGE_EVENTS_GENERAL && task.fileResult.length > 0 && !task.needRecalculatePackageTask
        });
        return filteredTable.length === 0
    }

    clearFilters() {
        this.taskIdFilter = null;
        this.taskIdFilterEdit = null;
        this.selectStatus = null;
        this.selectStatusEdit = null;
        this.selectReportType = null;
        this.selectReportTypeEdit = null;
        this.selectMarket = this.defaultFilterValue.value;
        this.selectMarketEdit = this.defaultFilterValue.value;
        this.selectGroup = this.defaultFilterValue.value;
        this.selectGroupEdit = this.defaultFilterValue.value;
        this.categoryOfProduct = this.defaultFilterValue.value;
        this.categoryOfProductEdit = this.defaultFilterValue.value;
        this.subCategoryOfProduct = [];
        this.subCategoryOfProductEdit = [];
        this.selectFormat = this.defaultFilterValue.value;
        this.selectFormatEdit = this.defaultFilterValue.value;
        this.selectRegion = [];
        this.selectRegionEdit = [];
        this.selectCluster = this.defaultFilterValue.value;
        this.selectClusterEdit = this.defaultFilterValue.value;
        this.categoryOptions = [this.defaultFilterValue];
        this.subCategoryOptions = this.defaultMultipleValue;
        this.formatOptions = this.defaultMultipleValue;
        this.regionOptions = this.defaultMultipleValue;
        this.clusterOptions = this.defaultMultipleValue;
        this.selectUserFio = 'All';
        this.selectUserFioEdit = 'All';
        this.updatedDateRange = [];
        this.updatedDateRangeEdit = [];
        this.taskNoteFilter = null;
        this.taskNoteFilterEdit = null;

        const pager = { ...this.pagination };
        pager.current = 1;
        this.pagination = pager;
        this.fetchList({
            currentPage: this.pagination.current,
            perPage: this.pagination.pageSize,
        }, () => {})
    }

    handleFilter() {
        const pager = { ...this.pagination };
        pager.current = 1;
        this.pagination = pager;
        this.fetchList({
            currentPage: this.pagination.current,
            perPage: this.pagination.pageSize,
        }, () => {})

      if (LocalData.zeroToNull(this.selectMarket) != null) {
        this.loadFilterOptions()
      }
    }

    changeDateRange(dateRange: string[]) {
        this.updatedDateRangeEdit = dateRange;
    }

    applyRegionFilter(confirm: () => void) {
      this.selectRegion = [...this.selectRegionEdit];

      if (this.pagination.current !== 1) {
        this.pagination.current = 1;
      }

      confirm();
      this.updateRegions(this.selectRegion);
      this.fetchList({
        currentPage: this.pagination.current,
        perPage: this.pagination.pageSize,
      }, () => {});
    }

    applySubcategoriesFilter(confirm: () => void) {
      this.subCategoryOfProduct = [...this.subCategoryOfProductEdit];

      if (this.pagination.current !== 1) {
        this.pagination.current = 1;
      }

      confirm();
      this.updateSubcategories(this.subCategoryOfProduct);
      this.fetchList({
        currentPage: this.pagination.current,
        perPage: this.pagination.pageSize,
      }, () => {});
    }

    applyTaskNoteFilter(confirm: () => void) {
      this.taskNoteFilter = this.taskNoteFilterEdit;

      if (this.pagination.current !== 1) {
        this.pagination.current = 1;
      }
      confirm();

      if (LocalData.zeroToNull(this.selectMarket) != null) {
        this.loadFilterOptions();
      }

      this.fetchList({
        currentPage: this.pagination.current,
        perPage: this.pagination.pageSize,
      }, () => {});
    }

    private taskTypeLabelMap: Record<string, string> = {
      [TaskType.REGULAR]: 'regular.taskTypes.regular',
      [TaskType.PACKAGE_REGULAR]: 'regular.taskTypes.package',
      [TaskType.PACKAGE_GENERAL]: 'regular.taskTypes.packageGeneral',
      [TaskType.PACKAGE_GENERAL_KVI_CARTS]: 'regular.taskTypes.packageByBasket',
      [TaskType.PACKAGE_GENERAL_KVI_RECOMMENDS]: 'regular.taskTypes.packageKviSearch',
      [TaskType.PACKAGE_PROMOTION]: 'regular.taskTypes.packagePromo',
      [TaskType.PACKAGE_GENERAL_PROMOTION]: 'regular.taskTypes.packageGeneralPromo',
      [TaskType.PACKAGE_SCHEDULE]: 'regular.taskTypes.scheduled',
      [TaskType.BRUT_FORCE]: 'regular.statuses.paramSearch',
      [TaskType.SEARCH_KVI]: 'regular.taskTypes.kviSearch',
      [TaskType.PROMO]: 'regular.columns.promo',
      [TaskType.PACKAGE_EVENTS]: 'regular.taskTypes.eventCalc',
      [TaskType.PACKAGE_EVENTS_GENERAL]: 'regular.taskTypes.eventCalcGeneral',
      [TaskType.PACKAGE_PROMO_GENERAL_RECOMMENDS]: 'regular.columns.promoRecommendations',
      [TaskType.PACKAGE_SCENARIO]: 'regular.taskTypes.scenario',
      [TaskType.PACKAGE_FIXED_PRICE]: 'regular.taskTypes.packageFixed',
      [TaskType.PACKAGE_GENERAL_FIXED_PRICE]: 'regular.taskTypes.packageGeneralFixed',
      [TaskType.REGULAR_PRICE_EXP]: 'regular.taskTypes.regularCe',
      [TaskType.SCHEDULED_PRICE_EXP]: 'regular.taskTypes.scheduledCe',
      [TaskType.SALES]: 'regular.taskTypes.sales',
      [TaskType.PACKAGE_SALES]: 'regular.taskTypes.packageSales',
      [TaskType.PACKAGE_GENERAL_SALES]: 'regular.taskTypes.packageGeneralSales',
      [TaskType.PACKAGE_AGGREGATE_SALES]: 'regular.taskTypes.packageAggregateSales',
      [TaskType.PACKAGE_GENERAL_AGGREGATE_SALES]: 'regular.taskTypes.packageGeneralAggregateSales',
      [TaskType.PACKAGE_GENERAL_PROMO]: 'regular.taskTypes.packageGeneralPromoCalc',
      [TaskType.PACKAGE_GENERAL_SCENARIO]: 'regular.taskTypes.packageGeneralScenario',
      [TaskType.PACKAGE_KVI_CARTS]: 'regular.taskTypes.packageKviCarts',
      [TaskType.PACKAGE_KVI_RECOMMENDS]: 'regular.taskTypes.packageKviRecommends',
      [TaskType.PACKAGE_PROMO]: 'regular.taskTypes.packagePromoCalc',
      [TaskType.PACKAGE_PROMO_RECOMMENDS]: 'regular.taskTypes.packagePromoRecommends',
      [TaskType.PROMOTION]: 'regular.taskTypes.promotion',
    };

    getTaskTypeLabel(typeValue: string): string {
      return localizeTaskType(typeValue);
    }

    getTaskStatusLabel(status: string): string {
      return localizeTaskStatus(status);
    }

    applyReportTypeFilter(confirm: () => void) {
      this.selectReportType = this.selectReportTypeEdit;

      if (this.pagination.current !== 1) {
        this.pagination.current = 1;
      }

      confirm();
      this.fetchList({
        currentPage: this.pagination.current,
        perPage: this.pagination.pageSize,
      }, () => {});
    }

    applyStatusFilter(confirm: () => void) {
      this.selectStatus = this.selectStatusEdit;

      if (this.pagination.current !== 1) {
        this.pagination.current = 1;
      }

      confirm();
      this.fetchList({
        currentPage: this.pagination.current,
        perPage: this.pagination.pageSize,
      }, () => {});
    }

    applyMarketFilter(confirm: () => void) {
      this.selectMarket = this.selectMarketEdit;

      if (this.pagination.current !== 1) {
        this.pagination.current = 1;
      }

      confirm();
      if (LocalData.zeroToNull(this.selectMarket) != null) {
        this.loadFilterOptions();
      }

      this.fetchList({
        currentPage: this.pagination.current,
        perPage: this.pagination.pageSize,
      }, () => {});
    }

    applyUserFioFilter(confirm: () => void) {
      this.selectUserFio = this.selectUserFioEdit;

      if (this.pagination.current !== 1) {
        this.pagination.current = 1;
      }

      confirm();
      this.fetchList({
        currentPage: this.pagination.current,
        perPage: this.pagination.pageSize,
      }, () => {});
    }

    applyGroupFilter(confirm: () => void) {
      this.selectGroup = this.selectGroupEdit;

      if (this.pagination.current !== 1) {
        this.pagination.current = 1;
      }

      confirm();
      this.resetByGroup();
      this.fetchList({
        currentPage: this.pagination.current,
        perPage: this.pagination.pageSize,
      }, () => {});
    }

    applyCategoryFilter(confirm: () => void) {
      this.categoryOfProduct = this.categoryOfProductEdit;

      if (this.pagination.current !== 1) {
        this.pagination.current = 1;
      }

      confirm();
      this.resetByCategory();
      this.fetchList({
        currentPage: this.pagination.current,
        perPage: this.pagination.pageSize,
      }, () => {});
    }

    applyClusterFilter(confirm: () => void) {
      this.selectCluster = this.selectClusterEdit;

      if (this.pagination.current !== 1) {
        this.pagination.current = 1;
      }

      confirm();
      this.resetByStoreCluster();
      this.fetchList({
        currentPage: this.pagination.current,
        perPage: this.pagination.pageSize,
      }, () => {});
    }

    applyFormatFilter(confirm: () => void) {
      this.selectFormat = this.selectFormatEdit;

      if (this.pagination.current !== 1) {
        this.pagination.current = 1;
      }

      confirm();
      this.resetByStoreFormat();
      this.fetchList({
        currentPage: this.pagination.current,
        perPage: this.pagination.pageSize,
      }, () => {});
    }

    applyTaskIdFilter(confirm: () => void) {
      this.taskIdFilter = this.taskIdFilterEdit;

      if (this.pagination.current !== 1) {
        this.pagination.current = 1;
      }

      confirm();
      this.fetchList({
        currentPage: this.pagination.current,
        perPage: this.pagination.pageSize,
      }, () => {});
    }

    applyUpdatedDateRangeFilter(confirm: () => void) {
      this.updatedDateRange = [...this.updatedDateRangeEdit];

      if (this.pagination.current !== 1) {
        this.pagination.current = 1;
      }

      confirm();
      this.fetchList({
        currentPage: this.pagination.current,
        perPage: this.pagination.pageSize,
      }, () => {});
    }

  async loadFilterOptions() {
          try {
            await Promise.all([
              this.getGroupInfo(),
              this.getCategoryInfo(),
              this.getSubcategoryInfo(),
              this.getStoreFormatsInfo(),
              this.getStoreRegionsInfo(),
              this.getStoreClustersInfo(),
            ]);
          } catch (e) {
          }
        }

    onFilterButtonClick() {
        this.handleFilter();
        this.selectOrClearAllReports(this.isAllReportsSelected);
    }

    resetByGroup() {
        this.resetData(TaskInfoFilterType.group)
    }

    resetByCategory() {
        this.resetData(TaskInfoFilterType.category)
    }

    resetByStoreFormat() {
        this.resetData(TaskInfoFilterType.format)
    }

    resetByStoreCluster() {
        this.resetData(TaskInfoFilterType.cluster)
    }

    updateSubcategories(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.subCategoryOfProduct)) {
            this.subCategoryOfProduct = list;
            this.resetBySubcategory();
        } else if (this.subCategoryOfProduct[0] === 0) {
            this.subCategoryOfProduct = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    updateRegions(list: number[]) {
        if (list.length > 0 && !LocalData.compareTwoArrays(list, this.selectRegion)) {
            this.selectRegion = list;
            this.resetByStoreRegion();
        } else if (this.selectRegion[0] === 0) {
            this.selectRegion = this.defaultIntSelectBox.map((i) => i.value);
        }
    }

    showStopButton(task: TaskData): boolean {
        return task.typeMachine === TaskType.BRUT_FORCE && task.status === TaskStatus.CALCULATING
    }

    showGenerateReportButton(task: TaskData): boolean {
      const isTaskReadyToBeGenerated =
          isTaskInBackgroundGeneratableTypesAndStatuses(task.typeMachine, task.status)

      return !task.fileResult.length && isTaskReadyToBeGenerated && !task.needRecalculatePackageTask
    }

    showGenerateRTNReportButton(task: TaskData): boolean {
      const isTaskReadyToBeGenerated =
          isRTNDocumentGeneratableTypesAndStatuses(task.typeMachine, task.status)
            && generatableRTNReportTaskStatuses.includes(task.rtnReportGenerationStatus)

      return this.globalSettings.isRTNDocumentEnabled &&
          !task.fileForRtnReport.length
          && isTaskReadyToBeGenerated
    }

  showDownloadButton(task: TaskData): boolean {
      const restrictedStatuses = [
        TaskStatus.CALCULATING,
        TaskStatus.CALCULATING_COMPLETE,
        TaskStatus.WRITETOFILE
      ].map((v) => v.valueOf())

      return !!task.fileResult.length
          && !task.needRecalculatePackageTask
          && !(restrictedStatuses.includes(task.status))
    }

  showRTNReportDownloadButton(task: TaskData): boolean {
    const restrictedStatuses = [
      TaskStatus.CALCULATING,
      TaskStatus.CALCULATING_COMPLETE,
      TaskStatus.WRITETOFILE
    ].map((v) => v.valueOf())

    return !!task.fileForRtnReport.length
        && !(restrictedStatuses.includes(task.rtnReportGenerationStatus))
        && this.globalSettings.isRTNDocumentEnabled
  }

    showSetDefaultParamButton(task: TaskData): boolean {
      const restrictedTaskTypes = [
        TaskType.PACKAGE_PROMO_GENERAL_RECOMMENDS,
        TaskType.SEARCH_KVI,
        TaskType.PACKAGE_GENERAL,
        TaskType.PACKAGE_GENERAL_SCENARIO,
        TaskType.PACKAGE_EVENTS_GENERAL,
      ]

      const isPackageTaskReadyToBeGenerated =
          isTaskInBackgroundGeneratableTypesAndStatuses(task.typeMachine, task.status)

      return !task.needRecalculatePackageTask
          && !restrictedTaskTypes.includes(task.typeMachine)
          && (task.fileResult.length > 0 || isPackageTaskReadyToBeGenerated)
    }

    showSaveFinalReportButton(task: TaskData): boolean {
        return task.status == TaskStatus.APPROVED
            && !!task.fileForRevaluationResult
    }

    showDownloadPriceButton(task: TaskData): boolean {
      // Для обычных задач - старая логика выгрузки цен
      const isPackageTaskReadyToBeGenerated =
          isTaskInBackgroundGeneratableTypesAndStatuses(task.typeMachine, task.status)

      const restrictedStatuses = [
        TaskStatus.CALCULATING,
        TaskStatus.CALCULATING_COMPLETE,
        TaskStatus.WRITETOFILE,
        TaskStatus.APPROVED,
        TaskStatus.SENT_TO_FINAL_APPROVAL,
        TaskStatus.ONAPPROVAL,
        TaskStatus.REJECTED,
        TaskStatus.PARTIALLY_REJECTED
      ].map((v) => v.valueOf())

      const restrictedRevaluationStatuses = [
        TaskStatus.APPROVED,
        TaskStatus.SENT_TO_FINAL_APPROVAL,
        TaskStatus.ONAPPROVAL,
        TaskStatus.REJECTED,
        TaskStatus.PARTIALLY_REJECTED
      ].map((v) => v.valueOf())

      return !task.needRecalculatePackageTask
          && !restrictedStatuses.includes(task.status)
          && !restrictedRevaluationStatuses.includes(task.revaluationStatus)
          && (!!task.fileResult.length || isPackageTaskReadyToBeGenerated)
    }

    stopBrutForcing(taskId: number) {
        this.httpExecutor.executeHttp(this.httpStopBrutForce, taskId)
                .then((r) => {
                    if (!r.ignore) {
                        this.refreshTable();
                        const resp = r.response;
                        if (resp.status === 204) {
                            this.showInfo(this.$t('regular.notifications.paramSearchStopped') as string)
                        } else if (resp.status === 404) {
                            this.showInfo(this.$t('regular.notifications.paramSearchNotFound') as string)
                        } else {
                            this.showError(this.$t('regular.errors.stopParamSearchFailed') as string)
                        }
                    }
                })
                .catch((e) => {
                    this.showError(this.$t('regular.errors.stopParamSearchFailed') as string)
                })
    }

    canBeShown(task: TaskData): boolean {
        const found = this.canBeShowTypes.findIndex((type) => task.typeMachine === type)
        if (found === -1) {
            return false;
        }

        return !task.needRecalculatePackageTask && (
            task.status === 'WriteToFileComplete' || 
            task.status === 'OnApproval' || 
            task.status === 'Rejected' || 
            task.status === 'Approved' ||
            task.status === 'PartiallyApproved' ||
            task.status === 'PartiallyRejected' ||
            task.status === 'SentToFinalApproval'
        );
    }

    selectResult(task: TaskData) {
        this.$router.push(`/reports/${task.id}`)
        let subCategories = ' - ';
        if (task.subcategories.length > 0) {
            subCategories = task.subcategories + ' / '
        }

        let formatName = ' - ';
        if (task.format !== '') {
            formatName = task.format + ' / '
        }

        let regionName = ' - ';
        if (task.region !== '') {
            regionName = task.region + ' / '
        }

        let clusterName = ' - ';
        if (task.cluster !== '') {
            clusterName = task.cluster + ' / '
        }
        const filters = task.group + ' / ' + task.category + ' / ' + subCategories + formatName + regionName + clusterName
        this.taskToView = {
            id: task.id,
            status: task.status,
            type: task.typeMachine,
            fileResult: task.fileResult,
            editable: task.editable,
            filterNames: filters,
            tradingId: task.tradingNetworks.id,
        };
        console.log(this.taskToView, "this.taskToView")

        // (this.$refs.resultViewTab as any).disabled = false;
        // (this.$refs.resultViewTab as any).activate();
        this.currentMainTab = "results"
    }

    selectPackageResult(task: ResultTableHeaders) {
        let subCategories = ' - ';
        if (task.subCategoryName !== '') {
            subCategories = task.subCategoryName + ' / '
        }

        let formatName = ' - ';
        if (task.formatName !== '') {
            formatName = task.formatName + ' / '
        }

        let regionName = ' - ';
        if (task.regionName !== '') {
            regionName = task.regionName + ' / '
        }

        let clusterName = ' - ';
        if (task.clusterName !== '') {
            clusterName = task.clusterName + ' / '
        }
        const filters = task.groupName + ' / ' + task.categoryName + ' / ' + subCategories + formatName + regionName + clusterName
        this.packageSubtask = {
            id: task.taskId,
            status: task.status,
            type: task.type,
            fileResult: task.fileResult,
            editable: task.editable,
            filterNames: filters,
        };
        this.currentMainTab ="resultPackageViewTab"
        // (this.$refs.resultPackageViewTab as any).disabled = false;
        // (this.$refs.resultPackageViewTab as any).activate();
    }

    taskIdPrevent(e: any) {
        if (e.key === 'Backspace' || e.key === 'Delete' || e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
            return
        }
        if (!/^\d+$/.test(e.key)) {
            e.preventDefault();
        }
    }

    private refreshTable() {
        if (this.$route.params.hasOwnProperty('id')) {
            this.$router.push('/reports');
        }
        this.currentPage = 1;
        (this.$refs.tasksTable as any).refresh();
    }

    private getTaskInfo(taskType: TaskInfoFilterType): GetTaskInfo {
        return {
            type: taskType,
            // tslint:disable-next-line: no-non-null-assertion
            tradingId: this.selectMarket!!,
            categories: LocalData.filterNumberArrays([this.categoryOfProduct], true),
            groups: LocalData.filterNumberArrays([this.selectGroup], true),
            subcategory: LocalData.filterNumberArrays(this.subCategoryOfProduct, true),
            segments: null,
            storeFormat: LocalData.filterNumberArrays([this.selectFormat], true),
            storeCluster: LocalData.filterNumberArrays([this.selectCluster], true),
            storeRegion: LocalData.filterNumberArrays(this.selectRegion, true),
            byReports: true,
        }
    }

    private resetBySubcategory() {
        this.resetData(TaskInfoFilterType.subcategory)
    }

    private resetByStoreRegion() {
        this.resetData(TaskInfoFilterType.region)
    }

    private resetData(type: TaskInfoFilterType | null = null) {
        switch (type) {
            case null:
                this.selectGroup = this.defaultFilterValue.value;
                this.categoryOfProduct = this.defaultFilterValue.value;
                this.subCategoryOfProduct = [];
                this.selectFormat = this.defaultFilterValue.value;
                this.selectRegion = [];
                this.selectCluster = this.defaultFilterValue.value;
                this.groupOptions = this.defaultMultipleValue;
                this.categoryOptions = [this.defaultFilterValue];
                this.subCategoryOptions = this.defaultMultipleValue;
                this.formatOptions = this.defaultMultipleValue;
                this.regionOptions = this.defaultMultipleValue;
                this.clusterOptions = this.defaultMultipleValue;
                break;
            case TaskInfoFilterType.group:
                this.categoryOfProduct = this.defaultFilterValue.value;
                this.subCategoryOfProduct = [];
                this.selectFormat = this.defaultFilterValue.value;
                this.selectRegion = [];
                this.selectCluster = this.defaultFilterValue.value;
                this.categoryOptions = [this.defaultFilterValue];
                this.subCategoryOptions = this.defaultMultipleValue;
                this.formatOptions = this.defaultMultipleValue;
                this.regionOptions = this.defaultMultipleValue;
                this.clusterOptions = this.defaultMultipleValue;
                Promise.all([
                  this.getCategoryInfo(),
                  this.getSubcategoryInfo(),
                  this.getStoreFormatsInfo(),
                  this.getStoreRegionsInfo(),
                  this.getStoreClustersInfo()
                ]);
                break;
            case TaskInfoFilterType.category:
                this.subCategoryOfProduct = [];
                this.selectFormat = this.defaultFilterValue.value;
                this.selectRegion = [];
                this.selectCluster = this.defaultFilterValue.value;
                this.subCategoryOptions = this.defaultMultipleValue;
                this.formatOptions = this.defaultMultipleValue;
                this.regionOptions = this.defaultMultipleValue;
                this.clusterOptions = this.defaultMultipleValue;
                Promise.all([
                  this.getSubcategoryInfo(),
                  this.getStoreFormatsInfo(),
                  this.getStoreRegionsInfo(),
                  this.getStoreClustersInfo()
                ]);
                break;
            case TaskInfoFilterType.subcategory:
                this.selectFormat = this.defaultFilterValue.value;
                this.selectRegion = [];
                this.selectCluster = this.defaultFilterValue.value;
                this.formatOptions = this.defaultMultipleValue;
                this.regionOptions = this.defaultMultipleValue;
                this.clusterOptions = this.defaultMultipleValue;
                Promise.all([
                  this.getStoreFormatsInfo(),
                  this.getStoreRegionsInfo(),
                  this.getStoreClustersInfo()
                ]);
                break;
            case TaskInfoFilterType.format:
                this.selectRegion = [];
                this.selectCluster = this.defaultFilterValue.value;
                this.regionOptions = this.defaultMultipleValue;
                this.clusterOptions = this.defaultMultipleValue;
                Promise.all([
                  this.getStoreRegionsInfo(),
                  this.getStoreClustersInfo()
                ]);
                break;
            case TaskInfoFilterType.region:
                this.selectCluster = this.defaultFilterValue.value;
                this.clusterOptions = this.defaultMultipleValue;
                this.getStoreClustersInfo();
                break;
        }
    }

    private getGroupInfo() {
        return this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.group))
                .then((data) => {
                    const filterData = data.data;
                    this.groupOptions = filterData.groups.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.groupOptions.unshift(this.defaultFilterValue, this.secondDefaultFilterValue);
                })
                .catch((e) => {
                })
    }

    private getCategoryInfo() {
        return this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.category))
                .then((data) => {
                    const filterData = data.data;
                    this.categoryOptions = filterData.categories.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.categoryOptions.unshift(this.defaultFilterValue);
                })
                .catch((e) => {
                })
    }

    private getSubcategoryInfo() {
       return this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.subcategory))
                .then((data) => {
                    const filterData = data.data;
                    this.subCategoryOptions = filterData.subcategories.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.subCategoryOptions.unshift(this.defaultFilterValue, this.secondDefaultFilterValue)
                })
                .catch((e) => {
                })
    }

    private getStoreFormatsInfo() {
       return this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.format))
                .then((data) => {
                    const filterData = data.data;
                    this.formatOptions = filterData.storeFormat.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.formatOptions.unshift(this.defaultFilterValue, this.secondDefaultFilterValue)
                })
                .catch((e) => {
                })
    }

    private getStoreRegionsInfo() {
       return this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.region))
                .then((data) => {
                    const filterData = data.data;
                    this.regionOptions = filterData.storeRegion.map((i) => {
                        return {value: i.id, label: i.name}
                    });
                    this.regionOptions.unshift(this.defaultFilterValue, this.secondDefaultFilterValue)
                })
                .catch((e) => {
                })
    }

    private getStoreClustersInfo() {
        return this.httpGetProductInfo(this.getTaskInfo(TaskInfoFilterType.cluster))
                .then((data) => {
                    const filterData = data.data;
                    this.clusterOptions = filterData.storeCluster.map((i) => {
                        return {value: i.id, label: i.name}
                    }, this.secondDefaultFilterValue);
                    this.clusterOptions.unshift(this.defaultFilterValue, this.secondDefaultFilterValue)
                })
                .catch((e) => {
                })
    }

    private viewReport(id: string) {
        const taskId = parseInt(id);
        if (taskId !== undefined) {
            this.httpLoadTaskById(taskId)
                    .then((resp) => {
                        if (resp.status === 200 && this.canBeShown(resp.data)) {
                            this.selectResult(resp.data)
                        } else {
                            this.showInfo(this.$t('resultView.messages.empty') as string);
                            this.$router.push('/reports');
                        }
                    })
                    .catch((ex) => {
                        this.showError(this.$t('resultView.messages.notFound') as string);
                        this.$router.push('/reports');
                    });
        }
    }

    private isFilterDisabled(): boolean {
      const market = this.selectMarket;
      return LocalData.zeroToNull(market) == null;
    }
}
